// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CartProvider } from './context/CartContext';
import Navigation from './components/layout/Navigation';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/layout/ScrollToTop';
import CartDrawer from './components/cart/CartDrawer';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import Lessons from './pages/Lessons';
import Contact from './pages/Contact';
import AboutUs from './pages/AboutUs'
import CareGuide from './pages/CareGuide';
import './App.css';


const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <CartProvider>
        <Router>
          <ScrollToTop />
          <div className="min-h-screen bg-linen-50">
            <Navigation />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/lessons" element={<Lessons />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/aboutus" element={<AboutUs />} />
              <Route path="/care" element={<CareGuide />} />
            </Routes>
            <Footer />
            <CartDrawer />
          </div>
        </Router>
      </CartProvider>
    </QueryClientProvider>
  );
}

export default App;